import { render, staticRenderFns } from "./analysisJg.vue?vue&type=template&id=85127052&scoped=true"
import script from "./analysisJg.vue?vue&type=script&lang=js"
export * from "./analysisJg.vue?vue&type=script&lang=js"
import style0 from "./analysisJg.vue?vue&type=style&index=0&id=85127052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85127052",
  null
  
)

export default component.exports